
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexMJJbSeQ_iQhe5_pKIIX6DpScz3MDFU807mimV7pqoJAMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/index.vue?macro=true";
import { default as indexyWCCF98e9yWy3JC67I5SL58gTx9M8wAwy_WufwAkeeYMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspacekt69Yb09EjfkwRsfiXT1F0gR_45_2kBbvRr2TO5cfIDN8Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexIC6iCfulbmvkXOLx75tcRECC6kYThns5900OZ4KwMk8Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexpbmHjnQCE5k3ksQv1oUqDjBm7MWyTiDjLacpWbBo_45UYMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as indexvdVWoaMg4QZu7En2Pd27QKNDVlp88pspoFs_458ZxJcWkMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as indexUbWA3FuNMJb2wzjJ405gtQXvqJtmnS_1cZSK13tulW0Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newCX7T6jReTSI4txv6EJVsRDZmoAOEZpqiKCxGEf_45hSwUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configurationka3WHYH23SpeyhHNd1ZiF2N3MtIWygSm8sx0OcAVeRcMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as indexVuF_45j7jFIKqk7sgaA0ybc0rkTNjezea09INNrCPacRcMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as m4QREVguiIPV45AeDdk3mI_459HU4QkC0snAezrGZTiALgMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as indexBc_456Ll2YEd0gYtkRXkHukYviMOv1oRN225S1Lg7axeoMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexL0Zg_JkcYFDxNqKxe_45NEddbl7e8WC655vaxj7VJTduEMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as indexOpedSAzpJbB6fXxEWqeqLtLiQE0hjJdO9wnpptQ4RcQMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as indexv12SrnM4h19mt_sZMC2RHri9p4dYRrQNbqLti_Hv11wMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signupITz83WH99jt9PIPwm8VpYNyAck8Ldu_45ccM5k5EZxMGkMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indexd8qO09z36ar9qaeF4O_wGBx5fGKtSU5TRj7fGXckkuEMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as indexVxox4njlRvoGr72NgKzVJTHYgJFiQyhsjc_gMTHsVNYMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as indexpy3vRC_45ONJIn_dAs1_cZVaYYfSh9xiCNk7Go_45pBKXNYMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newEJA3IheN9_v_GvbbJg5DzBZeJX_45yXZFfPr_das7FFW0Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93ORw3cb7JueiivUHV56VPR3oNJLDEAnwBRKCsFRdC9gwMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as indexEiba0k9jL6uc0BfYulsBWF1hYLG2zwYSQqs_45fdvVCrUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexNsynvUowLdEb5HmxosQfo4aUhdLA0W7qgff_45aOyrAUUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as indexWzAwRLGXM0sHo2T0dSDZhDryaMX2n9t9EG5RbSmDg_oMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as index9PVUe1CEDxeqV4pX2wvu7Ipf4aNgm3PI1bfykg8m7QoMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexKr_eH8GOvcLGQRX_45CxXgtlYEoVXjXaWcolYyRX7mDI0Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as index5ZQ5mKtL19yDVPHnBSs4L1uwpVioDbchEEDPRSAmkUQMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexS3dVpHW9jmTZyiXTvDiCMOfpOSvLI5cI5AQTxivboLAMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93EbpqQUr_r50H7O3KCNxNmb7AnmmcHwsO0FXPWSIUB4YMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as indexkQF1L2Za7iTq_7wmQjo_45gwwo6tCULlmGE4Bp2jeGL90Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingspsswb9i0tKFUhdubiVn14dgj464hjiQ0ZqnGnsJdXnUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as index5QjliWhZAaGl_45fQYw0a_REAxjNCcW4_gcQcoxHcsjQsMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93PJsf4WT_fdGL4K6xFT9M5rORebVNsPZlrPj1Asbhj24Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexg0KLwaJrS_wjC3czRBBgi3Q4T8hYja1de38U_1YCPakMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as indexxpC8EGDtVb9V8FITGt3pjha54VpmHYPRdqzsYP4RvOsMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importzdpjZGmpvfX_1yUs60h1jBsK_h1R8MBswebUbpIv_vwMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemawaljPDg6xhLse1jdSP9G5c8ojAokfcuqXOlFxya7WbQMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as indexK_rZv916t4BPx_45eFM8SikMkanW0aDhpaj1y6ogM_UOIMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexipX5a4t4wLNOgFxSxrL1d5JzC5MRz1L0j2wCRK_45Miu8Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as history7d2oVZUJx7Yqpct1PN_45o6iA5VncxP25eh_EpOIwK81QMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studioLFvXyrAlkPJ_458eXbS2RjnyU5n6fk6yTtgeXokPcYHZgMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as indexttBWTk_45KT_6CDSDqD037IiitlgErAdmpVSsM_NQisQgMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as indexAkS1Q7rn01ZqwhE3IkwONZUPK2IEsMHDPZvROW1cRqsMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as indexqYLvbRUOk4SgaqhJOkBci2eQiVglsk_45Jbn9OSjjXa_45MMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as indexXVx9qsBi_JXxM5ytNFTXXQ35c7_oezTAEOFJ1y16J5UMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93jUDJpaBMUh6wgMCkVPhX67asGfk9h_ZpeTMIR3wud78Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexDhfRDqlDslkijUUZGoe1QmcsjhnKHqfSLrTiCsrDfS4Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as indexcjWgrvKTXdTF3pa6oVGvyLB6u1ul8vnPQrNbSjdhOwUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45password1Qdx9OTDVXwX5iSKKRCFXwelJIbT1iOAdYR31maZbOUMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as indexGbo_45l5VLQfNbL_45BWL7bA8XPf_yEbSFgnTsD_BfNHgs0Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as indexXeNsl5_KKWpaFA5Y2W14rXxth_fWL4TyEUib9WmOgMsMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexzJEhLgvki0iDO8hWXXYD9uddEfMo_45drNUj6YLtDc5FYMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93Mp8DFEKWitzLwt44UUfVwTJplqcRH4MomxNYuoIFxR8Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as index45gP6SEb92nPww6eKp5O3DPsNEqEe9kRProF0005ySIMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as indexPx28E0rLckTiZlGL68vVyNQDx1vCbPe7fk291HjCUA8Meta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as indexFzhATu4qsuyR2DssOhkFi5dml96DMvQLqkf4_459_BNcgMeta } from "/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexMJJbSeQ_iQhe5_pKIIX6DpScz3MDFU807mimV7pqoJAMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexMJJbSeQ_iQhe5_pKIIX6DpScz3MDFU807mimV7pqoJAMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: m4QREVguiIPV45AeDdk3mI_459HU4QkC0snAezrGZTiALgMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: m4QREVguiIPV45AeDdk3mI_459HU4QkC0snAezrGZTiALgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: indexvdVWoaMg4QZu7En2Pd27QKNDVlp88pspoFs_458ZxJcWkMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: indexUbWA3FuNMJb2wzjJ405gtQXvqJtmnS_1cZSK13tulW0Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newCX7T6jReTSI4txv6EJVsRDZmoAOEZpqiKCxGEf_45hSwUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configurationka3WHYH23SpeyhHNd1ZiF2N3MtIWygSm8sx0OcAVeRcMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: indexVuF_45j7jFIKqk7sgaA0ybc0rkTNjezea09INNrCPacRcMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: m4QREVguiIPV45AeDdk3mI_459HU4QkC0snAezrGZTiALgMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: m4QREVguiIPV45AeDdk3mI_459HU4QkC0snAezrGZTiALgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: indexvdVWoaMg4QZu7En2Pd27QKNDVlp88pspoFs_458ZxJcWkMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: indexUbWA3FuNMJb2wzjJ405gtQXvqJtmnS_1cZSK13tulW0Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newCX7T6jReTSI4txv6EJVsRDZmoAOEZpqiKCxGEf_45hSwUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configurationka3WHYH23SpeyhHNd1ZiF2N3MtIWygSm8sx0OcAVeRcMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: indexVuF_45j7jFIKqk7sgaA0ybc0rkTNjezea09INNrCPacRcMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexL0Zg_JkcYFDxNqKxe_45NEddbl7e8WC655vaxj7VJTduEMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexL0Zg_JkcYFDxNqKxe_45NEddbl7e8WC655vaxj7VJTduEMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studioLFvXyrAlkPJ_458eXbS2RjnyU5n6fk6yTtgeXokPcYHZgMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studioLFvXyrAlkPJ_458eXbS2RjnyU5n6fk6yTtgeXokPcYHZgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: indexOpedSAzpJbB6fXxEWqeqLtLiQE0hjJdO9wnpptQ4RcQMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingspsswb9i0tKFUhdubiVn14dgj464hjiQ0ZqnGnsJdXnUMeta?.name,
    path: "settings",
    meta: settingspsswb9i0tKFUhdubiVn14dgj464hjiQ0ZqnGnsJdXnUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: index5QjliWhZAaGl_45fQYw0a_REAxjNCcW4_gcQcoxHcsjQsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93PJsf4WT_fdGL4K6xFT9M5rORebVNsPZlrPj1Asbhj24Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexg0KLwaJrS_wjC3czRBBgi3Q4T8hYja1de38U_1YCPakMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: indexxpC8EGDtVb9V8FITGt3pjha54VpmHYPRdqzsYP4RvOsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importzdpjZGmpvfX_1yUs60h1jBsK_h1R8MBswebUbpIv_vwMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemawaljPDg6xhLse1jdSP9G5c8ojAokfcuqXOlFxya7WbQMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: indexK_rZv916t4BPx_45eFM8SikMkanW0aDhpaj1y6ogM_UOIMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexipX5a4t4wLNOgFxSxrL1d5JzC5MRz1L0j2wCRK_45Miu8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: history7d2oVZUJx7Yqpct1PN_45o6iA5VncxP25eh_EpOIwK81QMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studioLFvXyrAlkPJ_458eXbS2RjnyU5n6fk6yTtgeXokPcYHZgMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studioLFvXyrAlkPJ_458eXbS2RjnyU5n6fk6yTtgeXokPcYHZgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: indexOpedSAzpJbB6fXxEWqeqLtLiQE0hjJdO9wnpptQ4RcQMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingspsswb9i0tKFUhdubiVn14dgj464hjiQ0ZqnGnsJdXnUMeta?.name,
    path: "settings",
    meta: settingspsswb9i0tKFUhdubiVn14dgj464hjiQ0ZqnGnsJdXnUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: index5QjliWhZAaGl_45fQYw0a_REAxjNCcW4_gcQcoxHcsjQsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93PJsf4WT_fdGL4K6xFT9M5rORebVNsPZlrPj1Asbhj24Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexg0KLwaJrS_wjC3czRBBgi3Q4T8hYja1de38U_1YCPakMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: indexxpC8EGDtVb9V8FITGt3pjha54VpmHYPRdqzsYP4RvOsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importzdpjZGmpvfX_1yUs60h1jBsK_h1R8MBswebUbpIv_vwMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemawaljPDg6xhLse1jdSP9G5c8ojAokfcuqXOlFxya7WbQMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: indexK_rZv916t4BPx_45eFM8SikMkanW0aDhpaj1y6ogM_UOIMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexipX5a4t4wLNOgFxSxrL1d5JzC5MRz1L0j2wCRK_45Miu8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: history7d2oVZUJx7Yqpct1PN_45o6iA5VncxP25eh_EpOIwK81QMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: indexttBWTk_45KT_6CDSDqD037IiitlgErAdmpVSsM_NQisQgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: indexttBWTk_45KT_6CDSDqD037IiitlgErAdmpVSsM_NQisQgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: indexAkS1Q7rn01ZqwhE3IkwONZUPK2IEsMHDPZvROW1cRqsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: indexAkS1Q7rn01ZqwhE3IkwONZUPK2IEsMHDPZvROW1cRqsMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: indexqYLvbRUOk4SgaqhJOkBci2eQiVglsk_45Jbn9OSjjXa_45MMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: indexqYLvbRUOk4SgaqhJOkBci2eQiVglsk_45Jbn9OSjjXa_45MMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: indexXVx9qsBi_JXxM5ytNFTXXQ35c7_oezTAEOFJ1y16J5UMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: indexXVx9qsBi_JXxM5ytNFTXXQ35c7_oezTAEOFJ1y16J5UMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93jUDJpaBMUh6wgMCkVPhX67asGfk9h_ZpeTMIR3wud78Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93jUDJpaBMUh6wgMCkVPhX67asGfk9h_ZpeTMIR3wud78Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: indexcjWgrvKTXdTF3pa6oVGvyLB6u1ul8vnPQrNbSjdhOwUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: indexcjWgrvKTXdTF3pa6oVGvyLB6u1ul8vnPQrNbSjdhOwUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45password1Qdx9OTDVXwX5iSKKRCFXwelJIbT1iOAdYR31maZbOUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45password1Qdx9OTDVXwX5iSKKRCFXwelJIbT1iOAdYR31maZbOUMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: indexGbo_45l5VLQfNbL_45BWL7bA8XPf_yEbSFgnTsD_BfNHgs0Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: indexGbo_45l5VLQfNbL_45BWL7bA8XPf_yEbSFgnTsD_BfNHgs0Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexzJEhLgvki0iDO8hWXXYD9uddEfMo_45drNUj6YLtDc5FYMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexzJEhLgvki0iDO8hWXXYD9uddEfMo_45drNUj6YLtDc5FYMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93Mp8DFEKWitzLwt44UUfVwTJplqcRH4MomxNYuoIFxR8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93Mp8DFEKWitzLwt44UUfVwTJplqcRH4MomxNYuoIFxR8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: indexPx28E0rLckTiZlGL68vVyNQDx1vCbPe7fk291HjCUA8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: indexPx28E0rLckTiZlGL68vVyNQDx1vCbPe7fk291HjCUA8Meta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexFzhATu4qsuyR2DssOhkFi5dml96DMvQLqkf4_459_BNcgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: indexFzhATu4qsuyR2DssOhkFi5dml96DMvQLqkf4_459_BNcgMeta || {},
    component: () => import("/Users/mknarciso/Work/zazos-v1/zazos-boot/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]